<script>
import DialogBody from "../dialog/components/dialog-body.vue";
import DialogHeader from "../dialog/components/dialog-header.vue";
import DialogBase from "../dialog/components/dialog-base.vue";
import DialogActionbar from "../dialog/components/dialog-actionbar.vue";
import PixabayImageBrowser from "./PixabayImageBrowser.vue";
import {pixabaySearchService} from "./PixabaySearchService";

export default {
    name: "PixabayDialog",
    components: {PixabayImageBrowser, DialogActionbar, DialogBase, DialogHeader, DialogBody},
    props: {
        showDialog: Boolean,
    },
    data() {
        return {
            /** @type{PixabayImage[]} */
            selectedImages: [],
            /** @type{PixabaySearchService} */
            service: pixabaySearchService
        };
    },
    computed: {
        translations() {
            return {
                title: Lang.langGet('Import stock images'),
                subTitle: Lang.langGet('Powered by Pixabay'),
                previous: Lang.langGet('Previous'),
                next: Lang.langGet('Next')
            }
        },
        confirmText() {
            const count = this.selectedImages.length;

            if (!count) {
                return Lang.langGet('No image selected');
            }

            if (count === 1) {
                return Lang.langGet('Import selected image');
            }

            if (count > 5) {
                return Lang.langGet('Too many images selected');
            }

            return Lang.langGet('Import :count selected images', {count});
        },
        total() {
            return this.service.total;
        },
        currentHits() {
            return this.service.images.length;
        },
        currentPage() {
            return this.service.page;
        },
        totalPages() {
            return Math.ceil(this.service.total / this.service.perPage);
        },
        canNext() {
            return this.currentPage < this.totalPages;
        },
        canPrev() {
            return this.currentPage > 1;
        },
        disableSave() {
            if (!this.selectedImages.length) return true;

            return this.selectedImages.length > 5;
        }
    },
    methods: {
        reset() {
            this.selectedImages = [];
            this.service.reset();
        },
        onClose() {
            this.$emit('close');
            this.reset();
        },
        onConfirm() {
            this.$emit('confirm', this.selectedImages);
            this.reset();
        },
        /**
         * @param images {PixabayImage[]}
         */
        onSelected(images) {
            this.selectedImages = images;
        }
    },
    mounted() {
        this.scrollContainerEl = this.$refs.scrollContainer;
    }
}
</script>

<template>
    <dialog-base
        v-if="showDialog"
        :max-width="1280"
        :show-dialog="showDialog"
        @close="onClose"
    >
        <dialog-header
            :title="translations.title"
            :sub-title="translations.subTitle"
            @close="onClose"
        />
        <dialog-body>
            <div class="pixabay-dialog-container">
                <PixabayImageBrowser
                    multiple
                    preload
                    @update:selected="onSelected"
                />
            </div>
        </dialog-body>
        <dialog-actionbar
            :disableSave="disableSave"
            :confirm-text="confirmText"
            disable-keypress
            @save="onConfirm"
            @close="onClose"
        >
            <div>
                <v-btn
                    :disabled="!canPrev"
                    @click="service.prevPage()"
                >
                    {{ translations.previous }}
                </v-btn>

                <v-btn
                    :disabled="!canNext"
                    @click="service.nextPage()"
                >
                    {{ translations.next }}
                </v-btn>
            </div>
            <div class="d-flex align-center" v-if="total !== 0">
                {{ `Page ${currentPage} of ${totalPages}` }}
            </div>
        </dialog-actionbar>
    </dialog-base>
</template>

<style scoped>
.pixabay-dialog-container {
    height: 70vh;
}
</style>
